(function () {
  'use strict';

  angular
    .module('wink', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngAria',
      'ui.router',
      'ngclipboard',
      'ui.bootstrap',
      'ui.calendar',
      'toastr',
      'ngLodash',
      'angular-loading-bar',
      'angular-spinkit',
      'base64',
      'angular-timeline',
      'angularMoment',
      'angular.backtop',
      'infinite-scroll',
      'truncate',
      'ui.bootstrap',
      'slickCarousel',
      'yaru22.angular-timeago',
      'ngAudio'
    ]);

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar(lodash, $interval, moment, $state, UserService, WinkService) {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      link: linkFunction,
      controller: NavbarController,
      controllerAs: 'navbar',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function linkFunction($scope, element, attrs, navbar) {
      // title
      navbar.title = lodash.isEmpty(attrs.title) ? 'Wink' : attrs.title;
      // reload button
      navbar.reload = lodash.isEmpty(attrs.reload) ? false : attrs.reload;
      // menu button
      navbar.menu = lodash.isEmpty(attrs.menu) ? false : $scope.$eval(attrs.menu);
      // navigate button button
      navbar.navigate = lodash.isEmpty(attrs.navigate) ? true : $scope.$eval(attrs.navigate);
      // TImer
      if (!lodash.isEmpty(attrs.timer) && $scope.$eval(attrs.timer) === true) {

        /**
         * Affichage de l'heure.
         * @type {string}
         */

        navbar.timer = moment().format('DD MMM HH:mm');

        var timerInterval = $interval(function () {
          navbar.timer = moment().format('DD MMM HH:mm');
        }, 60000);

        $scope.$on('$destroy', function () {
          $interval.cancel(timerInterval);
        });
      }

      /**
       * Effectuer une reload sur le contrôleur.
       * @method doReload
       * @return {[type]}
       */

      navbar.doReload = function () {
        if (!navbar.reload) {
          return false;
        }

        $scope.$eval(attrs.reload);
      };


    }

    function NavbarController() {
      var vm = this;

      /**
       * Méthode de déconnexion.
       * @method logout
       * @return {}
       */

      vm.logout = function () {
        UserService
          .logout()
          .then(function () {
            $state.go('logout');
          });
      }

      // Navigation à la prochaine Kee.
      vm.next = function () {
        WinkService.goToNextKee();
      };
      // Navigation à la précendte Kee.
      vm.prev = function () {
        WinkService.goToPrevKee();
      };
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .directive('loader', loader);

  /** @ngInject */
  function loader() {

    var directive = {
      restrict: 'E',
      template: '<div class="loader-container" ng-if="isVisible"><double-bounce-spinner></double-bounce-spinner></div>',
      link: linkFunc
    };

    return directive;

    function linkFunc($scope) {

      $scope.isVisible = false;

      $scope.$on('$stateChangeStart', function () {
        $scope.isVisible = true;
      });

      $scope.$on('$stateChangeSuccess', function () {
        $scope.isVisible = false;
      });

      $scope.$on('$stateChangeError', function () {
        $scope.isVisible = false;
      });

    }


  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .directive('autofocus', autofocus)

  function autofocus($timeout) {

    var directive = {
      restrict: 'A',
      link: linkFunc
    };

    return directive;

    function linkFunc($scope, element) {
      $timeout(function () {
        element[0].focus();
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .factory('WinkService', WinkService)

  function WinkService($q, $http, lodash, $stateParams, $log, $state, $injector, API) {

    /**
     * Cette variable contient les kees de l'utilsiateur une fois chargé.
     */

    var _storedKees = null;


    /**
     * Cette variable indique la kee actuellement consultée.
     * Cette varible est assignée lorsqu'on entre dans une kee
     * et remise à zéro lorsqu'on quitte la kee.
     */

    var _currentKee = null;

    return {

      /**
       * Récupération du hash du wink
       * @method getWinkHash
       * @return {}
       */

      getWinkHash: function () {
        return $stateParams.hash;
      },

      /**
       * Récupérer les kees de l'utilisateur.
       * @method getKees
       * @return {}
       */

      getKees: function () {

        var defer = $q.defer();

        if (!lodash.isEmpty(_storedKees)) {
          return $q.resolve(_storedKees)
        }

        var request = $http({
          url: API + '/wink/kees',
          method: 'GET'
        })

        request
          .then(function (response) {
            _storedKees = response.data;
            defer.resolve(_storedKees);
          })

        return defer.promise;

      },

      /**
       * On enregistre la kee que l'on souhaite consulter.
       * Cela permet au service de la kee de retrouver facilement l'id et sa configuration.
       * @method registerKee
       * @param  {int|}    keeID
       */

      registerKee: function (keeID) {
        // cast
        keeID = lodash.toInteger(keeID);
        // recherche de la kee dans les kees.
        _currentKee = lodash.find(_storedKees, {
          "id": keeID
        });

        return _currentKee;
      },

      /**
       * Cette méthode supprime la kee actuellement consultée.
       * @method unregisterKee
       * @return {}
       */

      unregisterKee: function () {
        _currentKee = null;
      },

      /**
       * Cette méthode permet d'envoyer l'utilisateur vers la kee qu'il a demandé.
       * @method goToKee
       * @param  {Object} kee
       * @return {$state.go}
       */

      goToKee: function (kee) {

        // On récupère la route de la kee.
        var route = lodash.get(kee, 'catalogue.name');

        if (route) {
          $state.go('app.kee.' + route, {
            keeId: kee.id
          });

        }
      },

      /**
       * Aller à la kee suivante.
       * @method goToNextKee
       * @return {this.goToKee}
       */

      goToNextKee: function () {

        var current = lodash.findIndex(_storedKees, {
          "id": _currentKee.id
        });

        var next = _storedKees[(current + 1) % _storedKees.length];

        return this.goToKee(next)
      },

      /**
       * Revenir à la kee précédente.
       * @method goToPrevKee
       * @return {this.goToKee}
       */

      goToPrevKee: function () {

        var current = lodash.findIndex(_storedKees, {
          "id": _currentKee.id
        });

        var previous = _storedKees[(current + _storedKees.length - 1) % _storedKees.length];

        return this.goToKee(previous)
      },

      /**
       * Récupérer le catalogue d'une kee.
       * Le catatalogue possède la configuraiton d'une kee.
       * @method getCatalogue
       * @param  {int}     $keeId
       * @return {}
       */

      getCurrentKee: function () {

        if (lodash.isEmpty(_currentKee)) {
          return $log.error('Aucune kee actuellement enregistrée')
        }

        return _currentKee;
      }

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .factory('UserService', UserService)

  function UserService($q, $http, $window, $state, lodash, WinkService, API, StoreService) {

    /**
     * La requête est traitée avec succès
     */

    var _HTTP_STATUS_SUCCESS = 200;

    /**
     *  La requête est traitée avec succès mais ne garantit pas un résultat.
     *  Par ex : L'authentification via le hash demande un PIN
     */

    var _HTTP_STATUS_ACCEPTED = 202;

    /**
     *  On a bien pointé vers le wink mais on est limité par un limiation par ip.
     */

    var _HTTP_STATUS_UNAUTHORIZED = 401;


    return {

      /**
       * Définis si l'utilisateur a une session active.
       * Cette session est activée lorsque on est connecté.
       * @method hasSession
       * @return {Boolean}
       */

      hasSession: function () {

        var session = StoreService.get("user");

        if (lodash.isEmpty(session)) {
          return false;
        }

        return true;
      },


      /**
       * Récupération d'une session (token)
       * @method getSession
       * @return {string}
       */

      getSession: function (key) {
        return StoreService.get("user", key);
      },

      /**
       * Retour du token.
       * @method getToken
       * @return {string}
       */

      getToken: function () {
        var token = this.getSession('token');
        // return token
        return token;
      },


      /**
       * Accès par wink via le hash.
       * Première étape de seucrité
       * @method accessByToken
       * @param  {string}      hash     Jeton.
       * @return {promise}
       */

      accessByToken: function (hash) {

        var defer = $q.defer();
        var self = this;

        var request = $http({
          url: API + '/user/token',
          method: 'POST',
          data: {
            "token": hash
          }
        })

        request
          .then(

            function success(response) {
              // Si on obtient un 200, on resolve en indiquant qu'on peut sauter l'étape du PIN
              if (response.status === _HTTP_STATUS_SUCCESS) {
                //store token.
                // Création du store.
                StoreService.add("user", response.data);

                defer.resolve({
                  hasWinkPin: false
                })
              }
              // Si on obtient un 202, on resolve en indiquant qu'on doit passer à l'étape du PIN
              if (response.status === _HTTP_STATUS_ACCEPTED) {
                defer.resolve({
                  hasWinkPin: true
                })
              }

            },
            function fail(error) {

              if (error.status === _HTTP_STATUS_UNAUTHORIZED) {

                defer.reject({
                  hasLimitationByIp: true
                });

              } else {
                defer.reject({
                  hasLimitationByIp: false
                });
              }

            })

        return defer.promise;
      },

      /**
       * Accéder avec le pin
       * @method accessByPin
       * @param  {string}    hash
       * @param  {int}      pin
       * @param  {object}    kee
       * @return promise
       */

      accessByPin: function (hash, pin, kee) {

        var defer = $q.defer();
        var self = this;
        var keeId = null;
        // Si on authentifie une kee.
        if (!lodash.isEmpty(kee)) {
          keeId = kee.id
        }

        var request = $http({
          url: API + '/user/pin',
          method: 'POST',
          data: {
            "token": hash,
            "pin": pin,
            "keeId": keeId
          }
        })

        request
          .then(

            function success(response) {

              // Si on obtient un 200, on resolve en indiquant qu'on peut sauter l'étape du PIN
              if (response.status === _HTTP_STATUS_SUCCESS) {
                // Création du store.
                if (response.data) {
                  StoreService.add("user", response.data);
                }
                // resolve
                defer.resolve();
              }

            },
            function fail() {
              defer.reject();
            })

        return defer.promise;
      },

      /**
       * Méthode de déconnexion.
       * @method logout
       * @return {[type]}
       */

      logout: function () {

        var defer = $q.defer();

        var request = $http({
          url: API + '/logout',
          method: 'POST'
        })

        request
          .then(

            function success() {
              // Création du store.
              StoreService.delete("user");
              defer.resolve();
            },
            function fail() {
              defer.reject();
            })

        return defer.promise;
      }


    }
  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .directive('supportIssue', SupportIssueDirective);

  function SupportIssueDirective(toastr) {

    var directive = {
      restrict: 'ACE',
      controllerAs: 'supportIssue',
      templateUrl: 'app/support/supportIssue.template.html',
      scope: {
        issue: '=?'
      },
      link: function ($scope, element, attrs, supportIssue) {
        supportIssue.issue = $scope.issue;

        $scope.copyClipboard = function () {
          toastr.success('Copié dans le presse-papier');
        }
      },
      controller: function () {}
    }


    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .factory('SupportService', SupportService);

  function SupportService($q, $http, $rootScope, UserService, lodash, API, WinkService) {


    /**
     * Cette variable contient lee support.
     * @type {[type]}
     */

    var _storedSupport = null;

    /**
     * Cette varable contient la dernière demande de support
     * @type {object}
     */

    var _lastIssue = null;


    return {

      /**
       * Récupération des tâches du scrum.
       * @method get
       * @param {bool}    autoreload
       * @return {[type]}
       */

      get: function (autoreload) {
        // Récupération des informations de la kee
        var keeInfo = WinkService.getCurrentKee();
        // Si on a déjà des transmissiosn lorsqu'on initialise la vue,
        // on les retournes.
        if (!lodash.isEmpty(_storedSupport) && autoreload !== true) {
          return $q.resolve(_storedSupport);
        }

        var defer = $q.defer();

        $http({
            url: API + '/kee/support',
            method: 'GET',
            params: {
              id: keeInfo.id
            }
          })
          .then(
            function (response) {
              _storedSupport = response.data;
              // Si ce n'est pas une récupération automatique.
              if (!autoreload) {
                // Récupération de la dernière demande support.
                var firstIssueOfResponse = lodash.head(_storedSupport.issues) || null;
                // Assignation de la dernière demande
                _lastIssue = firstIssueOfResponse;
              }
              // on retourne la promesse
              defer.resolve(_storedSupport);
            },
            function () {
              defer.reject();
            });

        return defer.promise;
      },

      /**
       * Récupérer depuis l'auto-reload.
       * @method getFromAutoReload
       * @return {get}
       */

      getFromAutoReload: function () {
        var defer = $q.defer();
        var self = this;

        this
          .get(true)
          .then(function (support) {
            var issues = support.issues;
            // récupération de la dernière demande de support
            var firstIssueOfResponse = lodash.head(issues) || null;
            // On vérifie si il y a une nouvele demande de support,
            if (firstIssueOfResponse) {
              // S'il n'y avait pas de précédente demande en mémoire.
              // On envoie un event pour jouer le sn.
              if (_lastIssue === null) {
                self._broadcastEventForPlayingSound(firstIssueOfResponse);
              }
              // Si l'id de la nouvelle demande est plus grand que l'ancienne.
              // On envoie un event pour jouer le son
              if (_lastIssue && firstIssueOfResponse.id > _lastIssue.id) {
                self._broadcastEventForPlayingSound(firstIssueOfResponse);
              }
              // Assignation de la dernière demande
              _lastIssue = firstIssueOfResponse;
            }

            defer.resolve(support);
          })

        return defer.promise;
      },

      /**
       * Cette méthode se charge d'envoyer un event vers les contrôleurs pour jouer un son
       * @method _broadcastEventForPlayingSound
       * @param  {object}                       issue SupportIssue object
       * @return {bool}
       */

      _broadcastEventForPlayingSound: function (issue) {
        // Si cette demande est bloquante.
        if (issue.is_high) {
          $rootScope.$broadcast('SupportService.newblock')
        } else {
          $rootScope.$broadcast('SupportService.new')
        }

        return true;
      }


    }
  }



})();

(function () {
  'use strict';

  angular
    .module('wink')
    .controller('SupportController', SupportController);

  function SupportController($scope, moment, $timeout, lodash, $interval, SupportService, $http, support, WINK, ngAudio) {
    var vm = this;

    //data
    vm.issues = support.issues;
    vm.statistics = support.statistics;
    vm.responsibles = support.responsibles;

    // fetching data
    // fix this : https://github.com/devmark/angular-slick-carousel#slide-data
    vm.dataLoaded = true;

    /**
     * Configuration Slick Support.
     * @type {Object}
     */
    vm.slickIssuesConfigIndex = 0;
    vm.slickIssuesConfig = {
      enabled: vm.issues.length > 3 ? true : false,
      infinite: true,
      centerMode: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      centerPadding: '0px',
      slidesToShow: 3,
      arrows: false,
      event: {
        afterChange: function (event, slick, currentSlide) {
          // on sauvegarde l'index à chaque load du support.
          vm.slickIssuesConfigIndex = currentSlide;
        },
        init: function (event, slick) {
          // on repositionne l'index à chaque fis que que slick est réeinitialisé
          slick.slickGoTo(vm.slickIssuesConfigIndex);
        }
      },
      responsive: [{
        centerMode: false,
        breakpoint: 992,
        settings: {
          centerPadding: '0px',
          slidesToShow: 2
        }
      }, {
        breakpoint: 768,
        centerMode: false,
        settings: {
          centerPadding: '0px',
          slidesToShow: 1
        }
      }]
    };

    /**
     * Configuration Slick responsable.
     * @type {Object}
     */

    vm.slickResponsibleConfig = {
      infinite: true,
      enabled: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1300
    }

    // Jouer un son
    $scope.$on('SupportService.new', function () {
      vm.slickIssuesConfigIndex = 0;
      ngAudio.play('assets/audio/audioIssue.mp3');
    });
    // Jouer un son d'une demande bloquante.
    $scope.$on('SupportService.newblock', function () {
      vm.slickIssuesConfigIndex = 0;
      ngAudio.play('assets/audio/audioIssueImportant.mp3');
    })

    /**
     * Interval de synchronisation des données
     * @type {int}
     */

    var syncInterval = (lodash.get(WINK, 'config.support.syncInterval', 60) * 1000);


    /**
     * Autoreload.
     * @method autoreload
     * @return {[type]}
     */

    vm.autoreload = function () {
      SupportService
        .getFromAutoReload()
        .then(function (support) {
          // on désactive slick.
          vm.dataLoaded = false;
          // nouvelles données..
          vm.issues = support.issues;
          vm.statistics = support.statistics;
          vm.responsibles = support.responsibles;

          if (vm.issues.length < 4) {
            vm.slickIssuesConfig.enabled = false;
          } else {
            vm.slickIssuesConfig.enabled = true;
          }

          // on réactive Slick.
          $timeout(function () {
            vm.dataLoaded = true;
          })
        });
    }

    /**
     * Synchronisation.
     * @type {[type]}
     */
    var sync = $interval(function () {
      vm.autoreload();
    }, syncInterval);

    /**
     * Lorsque le scope est détruit, ne pas oublier de détruire l'évènement setInterval (pour des raisons évidentes de perfomances.)
     */

    $scope.$on('$destroy', function () {
      $interval.cancel(sync);
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .factory('StoreService', StoreService);

  /**
   * SERVICE STORE
   */


  function StoreService(StoreConfiguration, $window, $log, lodash, $injector) {

    /**
     * Est ce que c'est un store en sessionStorage?
     * @type {bool}
     */

    var sessionStorage = StoreConfiguration.getType() === 'sessionStorage' ? true : false;

    return {

      /**
       * Retourne la nom préfixé d'un store.
       * Cette méthode éviter des confusions lorsqu'une même application utilise le  storage.
       * Par exemple une app stocke UsgBenef et l'autre app aussi, le  storage sera écrasé
       * @method _prefixStoreName
       * @param  {string}         name
       * @return {string}
       */

      _prefixStoreName: function (name) {
        return $injector.get('APP_STORAGE_PREFIX') + '_' + name;
      },

      /**
       * Enregistrement une donnée dans le store.
       * @method set
       * @param  {String} storeName Nom du store
       * @param  {any}    data Donnée à enregistrer
       **/

      set: function (storeName, data) {

        // On crée une copie des données pour éviter la référence.
        var _data = angular.copy(data);
        var self = this;
        // convert to json.
        _data = angular.toJson(_data);

        if (sessionStorage) {
          $window.sessionStorage[self._prefixStoreName(storeName)] = _data;
        } else {
          $window.localStorage[self._prefixStoreName(storeName)] = _data;
        }

      },

      /**
       * Récupérer les données d'un store passé en paramètre.
       * @method get
       * @param  {string} storeName Nom du store
       * @param  {any}    search    Recherche directement dans le store.
       * @return {any}
       */

      get: function (storeName, search) {

        var storedData;
        var self = this;

        // Récupération du store.
        if (sessionStorage) {
          storedData = $window.sessionStorage[self._prefixStoreName(storeName)];
        } else {
          storedData = $window.localStorage[self._prefixStoreName(storeName)];
        }

        // Si le store n'existe pas ou vide.
        if (lodash.isUndefined(storedData)) {
          return null;
        }
        // convert data.
        storedData = angular.fromJson(storedData);

        // Si on a défini une clé spécifique à récupérer.
        if (!lodash.isUndefined(search)) {
          var result = null;
          // Si les données sont de type array, on effectue un filter.
          if (lodash.isArray(storedData)) {
            result = lodash.filter(storedData, search);
          }
          // Si les données sont de type "Object", donc un non Array
          if (!lodash.isArray(storedData)) {
            result = lodash.get(storedData, search, null);
          }

          return result;
        }

        return storedData;

      },

      /**
       * Ajouter une donnée à un store existant.
       * @method add
       * @param  {string} storeName Nom du store
       * @param  {any} data      Données
       */

      add: function (storeName, data) {
        // On crée une copie des données pour éviter la référence.
        var _data = angular.copy(data);
        // Récupération du store.
        var store = this.get(storeName);
        // Si le store est vide, on le crée.
        if (store === null) {
          return this.set(storeName, _data);
        }

        // On merge les données.
        var newData = angular.merge(store, _data);
        // On met à jour notre store.
        this.set(storeName, newData);

        return true;
      },

      /**
       * Cette méthode permet de mettre à jour un store.
       * La donnée ciblée dans ce même store est récupéré par la remoteKey
       * @method update
       * @param  {string} storeName
       * @param  {any} data
       * @param  {string} remoteKey
       */

      update: function (storeName, data, remoteKey) {
        // remote key update.
        remoteKey = lodash.isUndefined(remoteKey) ? "id" : remoteKey;
        // On crée une copie des données pour éviter la référence.
        var _data = angular.copy(data);
        // Récupération du store.
        var store = this.get(storeName);
        // Si le store est vide, on le crée.
        if (store === null) {
          return this.set(storeName, _data);
        }

        // On recherche dans le store l'enregistrement lié.
        var search = {};
        search[remoteKey] = _data[remoteKey];
        var recordIndex = lodash.findIndex(store, search);

        // Si l'index est inconnu.
        if (recordIndex === -1) {
          return $log.error("Le store " + storeName + " ne contient pas d'enregistrement avec " + remoteKey + " est égal à " + _data[remoteKey]);
        }

        // on met à jour l'index.
        store[recordIndex] = _data;
        // On met à jour notre store.
        this.set(storeName, store);
      },

      delete: function (storeName) {

        var self = this;

        if (sessionStorage) {
          delete $window.sessionStorage[self._prefixStoreName(storeName)];
        } else {
          delete $window.localStorage[self._prefixStoreName(storeName)];
        }
      },

    };

  }


})();

(function () {
  'use strict';

  angular
    .module('wink')
    .provider('StoreConfiguration', StoreConfiguration);

  /**
   * Provider Store.
   */


  function StoreConfiguration() {

    /**
     * Type de storage possible.
     * @type {Array}
     */

    var typeOfStorage = ['sessionStorage', 'localStorage'];

    /**
     * Default storage.
     * 'sessionStorage' ou 'localStorage';
     * @type {String}
     */

    var storage = 'sessionStorage';

    /**
     * Définir le type de store
     * @method type
     * @param  {string}         type
     */

    this.setType = function (type) {

      if (typeOfStorage.indexOf(type) === -1) {
        throw new Error("Ce type de store n'existe pas. 'sessionStorage' & 'localStorage' sont des valeurs possibles.")
      }

      storage = type;
    }

    /**
     * @method $get
     */

    this.$get = function () {
      return {
        getType: function () {
          return storage;
        }
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('wink')
    .factory('ScrumService', ScrumService);

  function ScrumService($q, $http, UserService, lodash, API, WinkService) {


    /**
     * Cette variable contient les tâches d'un sprint.
     * @type {[type]}
     */

    var _storedSprint = null;

    return {

      /**
       * Récupération des tâches du scrum.
       * @method get
       * @param {bool}    autoreload
       * @return {[type]}
       */

      get: function (autoreload) {
        // Récupération des informations de la kee
        var keeInfo = WinkService.getCurrentKee();
        // Si on a déjà des transmissiosn lorsqu'on initialise la vue,
        // on les retournes.
        if (!lodash.isEmpty(_storedSprint) && autoreload !== true) {
          return $q.resolve(_storedSprint);
        }

        var defer = $q.defer();

        $http({
            url: API + '/kee/scrum',
            method: 'GET',
            params: {
              id: keeInfo.id
            }
          })
          .then(
            function (response) {

              if (response.status === 200) {
                _storedSprint = response.data;
                // on retourne la promesse
                defer.resolve(_storedSprint);
              }

              if (response.status === 204) {
                // on retourne la promesse
                defer.resolve(null);
              }

            },
            function () {
              defer.reject();
            });

        return defer.promise;
      },

      /**
       * Récupérer depuis l'auto-reload.
       * @method getFromAutoReload
       * @return {get}
       */

      getFromAutoReload: function () {
        return this.get(true);
      }



    }
  }



})();

(function () {
  'use strict';

  angular
    .module('wink')
    .controller('ScrumController', ScrumController);

  function ScrumController($scope, moment, lodash, $interval, ScrumService, $http, sprint, WINK) {
    var vm = this;

    /**
     * Assignation du sprint.
     * @type {[type]}
     */

    vm.sprint = sprint;
    /**
     * Ces statistiques sont utilisés dans les bares de progression.
     * @type {Object}
     */
    vm.statistics = {
      timer: 0,
      delivery: 0,
      complexity: {
        'pending': 0,
        'progress': 0,
        'finished': 0,
        'total': 0
      },
      // stats brutes.
      numberOfTasks: 0,
      numberOfTasksDone: 0,
      numberOfComplexity: 0,
      numberOfComplexityDone: 0
    };

    /**
     * Columns calculation
     * @type {Object}
     */

    vm.columns = {
      "pending": 4,
      "progress": 4,
      "finished": 4
    }

    /**
     * Interval de synchronisation des données
     * @type {int}
     */

    var syncInterval = (lodash.get(WINK, 'config.scrum.syncInterval', 600) * 1000);

    /**
     * %éthode pour calculer la somme des complexités d'une catégorie.
     * @method sumOfComplexity
     * @param  {{object}}        data
     * @return
     */

    var sumOfComplexity = function (data) {
      return lodash.sumBy(data, function (o) {
        return Number(o.complexity);
      });
    }

    /**
     * Attribuer une taille aux colonnes en fonction du nombre de demandes dispo.
     * @method columnsCalculation
     * @return {}
     */

    var columnsCalculation = function () {
      var _sprint = angular.copy(vm.sprint);
      // RATIO des demandes en cours.
      if (vm.statistics.numberOfTasks > 0) {
        vm.columns.pending = Math.round((_sprint.pending.length / vm.statistics.numberOfTasks) * 12);
        vm.columns.progress = Math.round((_sprint.progress.length / vm.statistics.numberOfTasks) * 12);
        vm.columns.finished = Math.round((_sprint.finished.length / vm.statistics.numberOfTasks) * 12);
      }

      if (vm.columns.pending + vm.columns.progress + vm.columns.finished < 12) {
        vm.columns.pending = 4;
        vm.columns.progress = 4;
        vm.columns.finished = 4;
      }

      if (vm.columns.pending >= 5) {
        vm.columns.pending = 8;
        vm.columns.progress = 2;
        vm.columns.finished = 2;
      }

      if (vm.columns.progress >= 5) {
        vm.columns.pending = 2;
        vm.columns.progress = 8;
        vm.columns.finished = 2;
      }

      if (vm.columns.finished >= 5) {
        vm.columns.pending = 2;
        vm.columns.progress = 2;
        vm.columns.finished = 8;
      }

    }

    /**
     * Cette fonction calcule la durée écoulée depuis le début du Sprint.
     * @method timerCalculation
     * @return {int}
     */

    var timerCalculation = function () {
      var _sprint = angular.copy(vm.sprint);
      // nombres de demandes divisé par le nombre de jours dans le sprint.
      // Calcul du nombre de jour dans le sprint.
      var numberOfDays = moment(_sprint.end).diff(_sprint.start, 'days');
      // Nombre de demandes
      // // Nombre de jours écoulé depuis le début de sprint.
      var numberOfDaysFromStart = moment().diff(_sprint.start, 'days');
      // progression
      vm.statistics.timer = (numberOfDaysFromStart / numberOfDays) * 100;
    };

    /**
     * Cette fonction calcule combien de tâches ont été réalisés
     * @method deliveryCalculation
     * @return {int}
     */

    var deliveryCalculation = function () {
      var _sprint = angular.copy(vm.sprint);
      // Nombre de tâches
      vm.statistics.numberOfTasks = (_sprint.pending.length + _sprint.progress.length + _sprint.finished.length);
      // Nombre de tâches terminées.
      vm.statistics.numberOfTasksDone = _sprint.finished.length;
      // garde fou.
      if (vm.statistics.numberOfTasksDone > 0 && vm.statistics.numberOfTasks > 0) {
        // progression
        vm.statistics.delivery = ((vm.statistics.numberOfTasksDone / vm.statistics.numberOfTasks) * 100).toFixed(0);
      }
    }

    /**
     * Calcul de la complexité
     * @method complexityCalculation
     * @return {int}
     */

    var complexityCalculation = function () {
      var _sprint = angular.copy(vm.sprint);
      // Sommes des complexités.
      vm.statistics.complexity.pending = sumOfComplexity(_sprint.pending);
      vm.statistics.complexity.progress = sumOfComplexity(_sprint.progress);
      vm.statistics.complexity.finished = sumOfComplexity(_sprint.finished);
      // complexité restante en terme de réalisation
      var remainingComplexity = (vm.statistics.complexity.pending + vm.statistics.complexity.progress);
      // Total des complexités.
      vm.statistics.numberOfComplexity = (remainingComplexity + vm.statistics.complexity.finished);
      // Complexité déjà  réalisée
      vm.statistics.numberOfComplexityDone = (vm.statistics.numberOfComplexity - remainingComplexity);
      // pourcentage de complexité.
      if (vm.statistics.numberOfComplexity > 0) {
        vm.statistics.complexity.total = (100 - (remainingComplexity / vm.statistics.numberOfComplexity * 100)).toFixed(0);
      }
    }

    // S'il y a un sprint
    if (vm.sprint) {
      timerCalculation();
      deliveryCalculation();
      complexityCalculation();
      columnsCalculation();
    }



    /**
     * Autoreload.
     * @method autoreload
     * @return {[type]}
     */

    vm.autoreload = function () {
      ScrumService
        .getFromAutoReload()
        .then(function (sprint) {
          // nouvelles tâches.
          vm.sprint = sprint;
          if (vm.sprint) {
            timerCalculation();
            deliveryCalculation();
            complexityCalculation();
            columnsCalculation();
          }
        })
    }

    /**
     * Récupérer lestransmissions toutes les x minutes, selon une configuration précise.
     */
    var sync = $interval(function () {
      vm.autoreload();
    }, syncInterval);

    /**
     * Lorsque le scope est détruit, ne pas oublier de détruire l'évènement setInterval (pour des raisons évidentes de perfomances.)
     */

    $scope.$on('$destroy', function () {
      $interval.cancel(sync);
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .directive('scrumCard', scrumCard)

  function scrumCard(lodash, $filter) {

    var directive = {
      restrict: 'E',
      link: linkFunc,
      controller: ScrumCardController,
      controllerAs: 'scrumCard',
      scope: {
        task: '=?'
      },
      templateUrl: 'app/scrum/scrum.card.template.html'
    };

    return directive;

    function linkFunc($scope, element, attrs, scrumCard) {

      // Statut.
      scrumCard.column = !lodash.isEmpty(attrs.column) ? attrs.column : 'pending';
      // Show responsable ?
      scrumCard.showResponsable = ['progress', 'finished'].indexOf(scrumCard.column) !== -1 && true;
      // show lisere ?
      scrumCard.showLisere = lodash.isEmpty(attrs.lisere) ? false : $scope.$eval(attrs.lisere);

      // Récupération du responsable.
      var responsable = lodash.get($scope.task, 'responsable_support');

      // Compositon du titre du popover.
      var title = '';
      title += $scope.task.model === 'SupportIssue' ? "#" : '$';
      title += $scope.task.id;
      title += ' ';
      title += $scope.task.name;

      // Compositon du contenu du popover.
      var content = '';
      // Affichage du gravatar et du nom.
      if (scrumCard.showResponsable) {
        content += '<img class="popover-gravatar" src="' + lodash.get(responsable, 'gravatar') + '"/>';
        content += '<div class="text-center responsable-name">';
        content += lodash.get(responsable, 'prenom', '?');
        content += '</div>';
        content += '<br>';
      }
      // Affichage de la description de la demande;
      content += $filter('words')($scope.task.description, 25);
      // Affichage du statut d'une demande terminée = Mr\Terminé
      if (scrumCard.column === 'finished') {
        content += '<br>';
        if ($scope.task.mr) {
          content += '<div class="text-warning text-right"> <i class="fa fa-compress text-warning"></i> Merge request</div>';
        } else {
          content += '<div class="text-success text-right"> <i class="fa fa-check text-success"></i> Terminée</div>'
        }
      }
      content += '<div class="text-warning text-right"><b>';
      content += 'Complexité : ';
      content += $scope.task.complexity ? $scope.task.complexity : '?';
      content += '</b></div>';

      //popover configuration
      scrumCard.popover = {
        title: title,
        content: content
      }

    }

    function ScrumCardController() {}


  }

})();

(function () {
  'use strict'

  angular
    .module('wink')
    .factory('HomeService', HomeService);

  function HomeService() {



    return {

    }

  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($stateParams, $state, lodash, UserService, kees, WinkService) {
    var vm = this;

    /**
     * Récupérationd des kees.
     * @type {array<Object>}
     */
    vm.kees = kees;

    /**
     * User
     * @type {string}
     */

    vm.user = UserService.getSession('name');

    /**
     * Accéder à la kee.
     * @method navigate
     * @param  {Object} kee
     * @return {}
     */

    vm.navigate = function (kee) {
      WinkService.goToKee(kee);
    }

  }


})();

(function () {
  'use strict';

  angular
    .module('wink')
    .factory('FastransService', FastransService);

  function FastransService($q, UserService, $http, moment, lodash, API, WinkService) {

    /**
     * Cette variable indique la page à laquelle on se trouve
     * pour consulter les transmissions selon une limit définie
     * par le serveur.
     * Cette variable est mis à jour après chaque appel aux transmissions
     * @type {Number}
     */

    var _page = 1;

    /**
     * Objet contenant les transmisisons
     * Transmissions.
     */

    var _storedTransmissions = null;

    return {

      /**
       * Analyse des transmissions et adapations au client
       * @method _parseTransmissions
       * @param  {array<object>}     serverTransmissions
       * @return {}
       */

      _parseTransmissions: function (serverTransmissions) {

        if (!lodash.isEmpty(serverTransmissions)) {
          // Traitement des transmissions.
          lodash.forEach(serverTransmissions, function (transmission) {
            // Cette transmission est-elle de nuit ?
            var hour = moment(transmission.date_fait).format('HH');
            transmission.nocturne = hour >= 21 || hour <= 7 ? true : false;
            // timeago
            transmission.timeAgo = moment(transmission.date_fait).fromNow();
            // Categorie
            // Assigination direct.
            transmission.categorie = lodash.get(transmission, 'categorie.name');
            // Create User.
            // Assigination direct.
            transmission.create_user = lodash.get(transmission, 'create_user.name');
            // Badge.
            // Badge pour une transmission importante / éducative.
            transmission.badge = transmission.important ? 'fa-exclamation-triangle' : 'fa-flag';
          })
        }

        return serverTransmissions;

      },

      /**
       * Récupération des données de la kee.
       * Cette méthode est appélée à l'initialisation de la route
       * @method get
       * @return {promise}
       */

      get: function () {
        // Récupération des informations de la kee
        var keeInfo = WinkService.getCurrentKee();
        // Si on a déjà des transmissiosn lorsqu'on initialise la vue,
        // on les retournes.
        if (!lodash.isEmpty(_storedTransmissions)) {
          return $q.resolve(_storedTransmissions);
        }

        var defer = $q.defer();
        var self = this;

        $http({
            url: API + '/kee/fastrans',
            method: 'GET',
            params: {
              id: keeInfo.id,
              page: 1
            }
          })
          .then(
            function (response) {
              _storedTransmissions = self._parseTransmissions(response.data.data);
              // on retourne la promesse
              defer.resolve(_storedTransmissions);
            },
            function () {
              defer.reject();
            });

        return defer.promise;
      },


      /**
       * Récupération des données de la kee avec le scroll infini.
       * @method getFromInfiniteScroll
       * @return {promise}
       */

      getFromInfiniteScroll: function () {

        var defer = $q.defer();
        var self = this;
        // Récupération des informations de la kee
        var keeInfo = WinkService.getCurrentKee();
        // On augmente la page.
        _page += 1;

        $http({
            url: API + '/kee/fastrans',
            method: 'GET',
            params: {
              id: keeInfo.id,
              page: _page
            }
          })
          .then(
            function (response) {
              // Si il y a plus de transmissions on rejette.
              if (lodash.isEmpty(response.data)) {
                defer.reject();
              } else {
                var newTransmissions = self._parseTransmissions(response.data);
                // Concaténation avec les anciennes transmissions.
                _storedTransmissions = lodash.concat(_storedTransmissions, newTransmissions);
                // on retourne la promesse
                defer.resolve(_storedTransmissions);
              }
            },
            function () {
              // Si ça échoué, on prends la précaution de remettre la page à sa valeur précédente.
              _page -= 1;
            });

        return defer.promise;
      },

      /**
       * Cette méthode est appelée lorsqu'on met à jour les transmissions via l'auto-refresh.
       * @method getFromAutoReload
       * @return {}
       */

      getFromAutoReload: function () {

        var defer = $q.defer();
        var self = this;
        // Récupération des informations de la kee
        var keeInfo = WinkService.getCurrentKee();
        // On récupère la dernière date fait
        // Si il n'existe pas, on la génère à partir de maintenant.
        var lastDateFait = lodash.isEmpty(_storedTransmissions) ? moment().format('YYYY-MM-DD HH:mm:ss') : _storedTransmissions[0].date_fait;

        $http({
            url: API + '/kee/fastrans',
            method: 'GET',
            params: {
              id: keeInfo.id,
              condition: "(@date_fait,'>'," + lastDateFait + ")"
            }
          })
          .then(
            function (response) {
              // Si on ne reçoit pas une réponse vide.
              if (!lodash.isEmpty(response.data)) {
                // On parse les transmissions qu'on recoit.
                response.data = self._parseTransmissions(response.data);
                // On les inject au début du tableau
                _storedTransmissions = response.data.concat(_storedTransmissions);
              }
              // on retourne la promesse
              defer.resolve(_storedTransmissions);
            },
            function () {
              defer.reject();
            });

        return defer.promise;
      }

    }

  }



})();

(function () {
  'use strict';

  angular
    .module('wink')
    .controller('FastransController', FastransController);

  function FastransController($scope, lodash, FastransService, $interval, transmissions, WINK) {
    var vm = this;

    /**
     * Interval de synchronisation des évènements
     * @type {int}
     */

    var syncInterval = (lodash.get(WINK, 'config.fastrans.syncInterval', 600) * 1000);

    /**
     * Assignation des transmissions.
     * @type {array<Object>}
     */

    vm.data = transmissions;

    /**
     * Filtres
     * @type {Object}
     */

    vm.toggle = {
      medical: false,
      nocturne: false,
      important: false
    }

    /**
     * Infinitescroll
     * @type {Object}
     */

    vm.infiniteScroll = {
      busy: false,
      complete: false
    };


    /**
     * Filtrer les transmissions avec les toggle.
     * Ecoute des changements sur les toggle.
     * @type {[type]}
     */

    $scope.$watchCollection('fastrans.toggle', function (toggleNewVal, toggleOldVal) {

      if (toggleNewVal === toggleOldVal) {
        return;
      }

      // On supprime les clefs avec la valeur false
      // car notre filtre veut afficher uniquement les valeurs avec true.
      lodash.forEach(toggleNewVal, function (toggle, key) {
        if (toggle === false) {
          delete toggleNewVal[key];
        }
      })

      var filteredData = lodash.filter(transmissions, toggleNewVal);
      vm.data = filteredData;

    });

    /**
     * Cette méthode est appelée lorsque le scroll infini est déclenché.
     * @method nextPage
     * @return {}
     */

    vm.nextPage = function () {
      // Si le scroll infini est occupé ou qu'il est complété.
      if (vm.infiniteScroll.busy || vm.infiniteScroll.complete) {
        return;
      }
      // On met en attente l'infiniti scroll.
      vm.infiniteScroll.busy = true;
      // On appel à nouveau les transmissions.
      FastransService
        .getFromInfiniteScroll()
        .then(function (newTransmissions) {
          // nouvelles transmissions.
          vm.data = newTransmissions;
          // On désactive l'attente.
          vm.infiniteScroll.busy = false;
        }, function () {
          // c'est rejeté, donc on est complet!
          vm.infiniteScroll.complete = true;
          // On désactive l'attente.
          vm.infiniteScroll.busy = false;
        });
    }

    /**
     * Autoreload
     * @method autoreload
     * @return {[type]}
     */

    vm.autoreload = function () {
      FastransService
        .getFromAutoReload()
        .then(function (newTransmissions) {
          // nouvelles transmissions.
          vm.data = newTransmissions;
        })
    }

    /**
     * Récupérer lestransmissions toutes les x minutes, selon une configuration précise.
     */
    var syncKee = $interval(function () {
      vm.autoreload();
    }, syncInterval);

    /**
     * Lorsque le scope est détruit, ne pas oublier de détruire l'évènement setInterval (pour des raisons évidentes de perfomances.)
     */

    $scope.$on('$destroy', function () {
      $interval.cancel(syncKee);
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .controller('AuthController', AuthController);

  /** @ngInject */
  function AuthController($stateParams, $state, $location, UserService) {
    var vm = this;

    /**
     * Formulaire
     * @type {Object}
     */

    vm.form = {
      pin: null,
      error: false
    };

    /**
     * Déclencheur de l'évènement submit
     * @method accessByPin
     * @return {}
     */

    vm.accessByPin = function () {
      vm.form.error = false;

      var hash = $stateParams.hash;
      var pin = angular.copy(vm.form.pin);

      UserService
        .accessByPin(hash, pin, $stateParams.kee)
        .then(

          function success() {
            if ($stateParams.kee) {
              $state.go('app.kee.' + $stateParams.kee.catalogue.name, {
                keeId: $stateParams.kee.id,
                hash: $stateParams.hash,
                hasAuthKee: true
              });
            } else {
              // ACCESS OK.
              $state.go('app.home');
            }
          },
          function error() {
            vm.form.error = true;
            // on vide le champ pin.
            vm.form.pin = null;
          })
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('wink')
    .factory('ActionCalendarService', ActionCalendarService);

  function ActionCalendarService($http, $q, UserService, lodash, moment, API, WINK, WinkService) {

    /**
     * Jours ajouté depuis maintenant (récuparation des évènements)
     * @type {int}
     */

    var dayAddedFromToday = lodash.get(WINK, 'config.actionCalendar.dayAddedFromToday', 2);

    /**
     * Temps à retirer à partir de maintenant
     * @type {int}
     */

    var minTimeFromNow = lodash.get(WINK, 'config.actionCalendar.minTimeFromNow', 3);

    /**
     * Temps à ajouter à partir de maintenant
     * @type {int}
     */

    var maxTimeFromNow = lodash.get(WINK, 'config.actionCalendar.maxTimeFromNow', 5);


    /**
     * Couleur par défaut pour les évènements
     * @type {String}
     */

    var defaultColor = "#838383";

    /**
     * Couleurs issues D'oGIRYS
     * @type {Array}
     */

    var colorPalette = [
      '#fa7166',
      '#7e3838',
      '#cf2424',
      '#133897',
      '#ca7609',
      '#D81B60',
      '#a01a1a',
      '#f88015',
      '#eda12a',
      '#d5b816',
      '#e281ca',
      '#bf53a4',
      '#9d3283',
      '#7a0f60',
      '#542382',
      '#7742a9',
      '#8763ca',
      '#b586e2',
      '#7399f9',
      '#4e79e6',
      '#2951b9',
      '#4E342E',
      '#1a5173',
      '#1a699c',
      '#3694b7',
      '#64b9d9',
      '#a8c67b',
      '#83ad47',
      '#2e8f0c',
      '#176413',
      '#0f4c30',
      '#386651',
      '#3ea987',
      '#7bc3b5',
      '#00897B'
    ];


    /**
     * Obtenir les jours qu'il faut cacher pour afficher le calendrier comme on le souhaite.
     * @method getHiddenDays
     * @param  {bool}     isFuture      Définit s'il faut calculer les futures jours ou pas
     * @return {array}
     */

    var getHiddenDays = function (isFuture) {

      var days = [0, 1, 2, 3, 4, 5, 6];
      var result;

      if (!isFuture) {

        result = lodash.remove(days, function (n) {

          // si on est un vendredi ou plus, il faut pouvoir afficher le dimanche/lundi..
          if (moment().day() >= 5 && n <= (moment().day() - moment().day() + dayAddedFromToday)) {
            return n;
          }

          return n < moment().day();
        });

      } else {

        result = lodash.remove(days, function (n) {

          // Si on est un vendredi ou plus.
          if (moment().day() >= 5) {
            return false;
          }

          return n > moment().add(dayAddedFromToday, 'days').day();
        });

      }

      return result;
    };

    /**
     * Cette variable contient les évènements et groupes.
     * @type {array<Object>}
     */

    var _storedData = null;

    return {

      /**
       * Cette méthode retourne la configuration du plugin fullcalendar basé sur sa doc.
       * @method fullCalendarConfiguration
       * @param  {object}                  evenements Les évènements a afficher dans le calendrier.
       * @return {object}
       */

      fullCalendarConfiguration: function (evenements, showCompleteCalendar) {

        var config = {
          events: evenements,
          height: 'auto',
          editable: false,
          defaultView: 'agendaWeek', // Only show week view
          header: false, // Hide buttons/titles
          slotLabelFormat: 'HH:mm',
          locale: 'fr',
          slotDuration: '00:30:00',
          hiddenDays: lodash.union(getHiddenDays(false), getHiddenDays(true)),
          allDayText: 'Journée',
          nowIndicator: true,
          displayEventTime: false,
          slotEventOverlap: false,
          firstDay: 1,
          dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
          monthNamesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
          views: {
            agendaWeek: {
              columnFormat: 'dddd DD MMM'
            }
          },
          // Forcer le html dans le rendu d'un évènement
          eventRender: function (event, element) {
            element.find('.fc-title').html(event.title);
          }
        };

        // Afficher le calendrier complet?
        if (!showCompleteCalendar) {

          var minTime = moment().startOf('hour').subtract(minTimeFromNow, 'hours').format('HH:00');
          var maxTime = moment().startOf('hour').add(maxTimeFromNow, 'hours').format('HH:00');
          // Heure maximum à laquelle min tim ne doit pas exéder
          var minTimeBeforeMidnight = moment("00:00", 'HH:mm').subtract(maxTimeFromNow, 'hours').format('HH:00');

          // Vérifier si l'heure maximum n'execede pas minuit.
          if (minTime >= minTimeBeforeMidnight) {
            maxTime = '23:59';
          }

          config.minTime = minTime;
          config.maxTime = maxTime;
        }

        return config;
      },

      /**
       * Cette méthode permet de générer le titre d'un évènement à partir de son objet de donnée.
       * @method _eventTitleFormat
       * @param  {object}          eventObject
       * @return {string}
       */

      _eventTitleFormat: function (eventObject) {

        var title = '';

        title += moment(eventObject.begin).format('HH:mm') + ' - ' + moment(eventObject.end).format('HH:mm') + ' | ';
        title += '<b>' + eventObject.title + '</b>';
        title += '<br>';

        // Professionnels
        if (!lodash.isEmpty(eventObject.event.acteurs)) {
          title += 'Pros : ';
          title += '<b>';
          // récupération ds professionnels
          var acteurs = lodash.map(eventObject.event.acteurs, 'name');
          title += lodash.join(acteurs, ', ');

          title += '</b>';
          title += '<br>';
        }

        // usagers
        if (!lodash.isEmpty(eventObject.event.usgbenef_participation)) {
          title += 'Usg : ';
          title += '<b>';

          // récupération des usagers
          var usgbenef = lodash.map(eventObject.event.usgbenef_participation, 'name');
          title += lodash.join(usgbenef, ', ');

          title += '</b>';
        }

        return title;
      },

      /**
       * Cette méthode s'occupe d'analyser et formater les évènements
       * pour être compatible avec le calendrier fullcalendar.
       * @method _parseEventsFromServer
       * @param  {array<Object>}               events
       * @return {array<Object>}
       */

      _parseEventsFromServer: function (events) {

        // SUPPRESSION DES DOUBLONS.
        var serverEvents = lodash.uniqBy(events, 'id');
        var winkEvents = [];
        var self = this;

        // traitement des events
        lodash.forEach(serverEvents, function (event) {

          var tmpEvent = {
            title: self._eventTitleFormat(event),
            start: event.begin,
            end: event.end,
            color: defaultColor
          };

          // COLOR
          if (!lodash.isNull(event.event.benef_group)) {
            tmpEvent.color = colorPalette[(event.event.benef_group % colorPalette.length)];
          }

          // ALL DAY?
          if (!moment(moment(event.begin).format('YYYY-MM-DD')).isSame(moment(event.end).format('YYYY-MM-DD'))) {
            tmpEvent.allDay = true;
          } else {
            tmpEvent.allDay = false;
          }

          winkEvents.push(tmpEvent);
        });

        return winkEvents;

      },

      /**
       * Cette méthode s'occupe d'analayser les groupes et leur associer une couleur.
       * @method _parseGroupsFromServer
       * @param  {array}               groups
       * @return {array}
       */

      _parseGroupsFromServer: function (groups) {

        if (lodash.isEmpty(groups)) {
          return null;
        }

        // traitement des groupes.
        lodash.forEach(groups, function (group) {
          group.color = colorPalette[(group.id % colorPalette.length)];
        });

        return groups;
      },

      /**
       * Récupération des évènements.
       * Cette méthode est appelée avant le chargement du contrôleur et de la vue
       * @method get
       * @return {[type]}
       */

      get: function (autoReload) {

        var defer = $q.defer();
        var self = this;

        if (!lodash.isEmpty(_storedData) && autoReload !== true) {
          return $q.resolve(_storedData);
        }

        // Récupération des informations de la kee
        var keeInfo = WinkService.getCurrentKee();

        $http({
            url: API + '/kee/action-calendar',
            method: 'GET',
            params: {
              id: keeInfo.id
            }
          })
          .then(
            function (response) {

              var clientData = {
                groups: null,
                events: null
              };

              if (!lodash.isEmpty(response.data)) {
                // Données analysées retournées à la vue.
                clientData.groups = self._parseGroupsFromServer(response.data.groups);
                clientData.events = self._parseEventsFromServer(response.data.events)
              }
              // enregistrement des données.
              _storedData = clientData;

              defer.resolve(clientData);
            },
            function () {
              defer.reject();
            });

        return defer.promise;
      },

      /**
       * Mise à jour via l'autoreload.
       * @method getFromAutoReload
       * @return {}
       */

      getFromAutoReload: function () {
        return this.get(true);
      }

    };

  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .controller('ActionCalendarController', ActionCalendarController);

  function ActionCalendarController($scope, $window, $interval, moment, lodash, WINK, ActionCalendarService, uiCalendarConfig, data) {
    var vm = this;

    /**
     * Interval de synchronisation des évènements
     * @type {int}
     */

    var syncInterval = (lodash.get(WINK, 'config.actionCalendar.syncInterval', 600) * 1000);

    /**
     * groupes
     * ORGGROUP.
     * @type {array<Object>}
     */

    vm.groups = data.groups;

    /**
     * Show complete calendar
     * @type {Object}
     */

    vm.toggle = {
      showCompleteCalendar: false
    };


    /**
     * Configuration du calendrier (fullcalendar) plugin
     * @type {object}
     */

    vm.fullCalendarConfiguration = ActionCalendarService.fullCalendarConfiguration(data.events, vm.toggle.showCompleteCalendar);



    $scope.$watch('actionCalendar.toggle.showCompleteCalendar', function (oldVal, newVal) {
      if (oldVal === newVal) {
        return;
      }

      vm.fullCalendarConfiguration = ActionCalendarService.fullCalendarConfiguration(data.events, vm.toggle.showCompleteCalendar);
    });

    /**
     * Autoreload.
     * @method autoreload
     * @return {[type]}
     */

    vm.autoreload = function () {
      ActionCalendarService
        .getFromAutoReload()
        .then(function (data) {
          vm.groups = data.groups;
          vm.fullCalendarConfiguration = ActionCalendarService.fullCalendarConfiguration(data.events, vm.toggle.showCompleteCalendar);
        });
    }

    /**
     * Récupérer les évènements|groupes toutes les x minutes, selon une configuration précise.
     */

    var sync = $interval(function () {
      vm.autoreload();
    }, syncInterval);

    /**
     * Lorsque le scope est détruit, ne pas oublier de détruire l'évènement setInterval (pour des raisons évidentes de perfomances.)
     */

    $scope.$on('$destroy', function () {
      $interval.cancel(sync);
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {

  }


})();

(function () {
  'use strict';

  angular
    .module('wink')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    // 404 page
    $stateProvider
      .state('404', {
        url: '/404',
        templateUrl: 'app/error-pages/404.html'
      });
    // 401 page
    $stateProvider
      .state('401', {
        url: '/401',
        templateUrl: 'app/error-pages/401.html'
      });
    // logout page
    $stateProvider
      .state('logout', {
        url: '/logout',
        templateUrl: 'app/logout/logout.html'
      });


    /**
     * POINT D'ENTREE DE L'APPLICATION
     */


    $stateProvider
      .state('app', {
        url: '/{hash}',
        template: '<div ui-view></div>',
        resolve: {
          hash: function ($q, $timeout, $state, $location, lodash, $stateParams, UserService) {
            // Route que l'utilisateur souhaite atteindre.
            var userUrlAttempt = $location.url();
            // Suppression du premier élement et du hash
            var userRouteAttempt = lodash.drop(lodash.split(userUrlAttempt, '/'), 2)
              // Est ce que l'utilisateur veut atteindre une route particulière ?
            var userWantsSpecificRoute = lodash.isEmpty(userRouteAttempt) ? false : true;

            // Si l'utilisateur a déjà une session active,
            // on laise passer.
            if (UserService.hasSession()) {
              return $q.resolve();
            }

            // Vérification du token
            return UserService
              .accessByToken($stateParams.hash)
              .then(function (response) {
                // Si le wink n'a pas de pin.
                // On laisse passer.
                if (response.hasWinkPin === false) {
                  // Si l'user souhaite une route particulière, il peut passer.
                  if (userWantsSpecificRoute) {
                    return $q.resolve()
                  }

                  // redirection vers la home.
                  $timeout(function () {
                    $state.go('app.home', {
                      hash: $stateParams.hash
                    });
                  });

                  return $q.resolve();

                }

                // Si le wink a un pin,
                // authentification requise
                if (response.hasWinkPin === true) {
                  $timeout(function () {
                    $state.go('app.auth', {
                      hash: $stateParams.hash
                    });
                  });
                }

                return $q.resolve();
              }, function (responseError) {

                if (responseError.hasLimitationByIp) {
                  $timeout(function () {
                    $state.go('401');
                  });
                } else {
                  $timeout(function () {
                    $state.go('404');
                  });
                }
                return $q.reject();
              })
          }
        }
      });


    /**
     * Vérification du code PIN
     */

    $stateProvider
      .state('app.auth', {
        url: '/auth',
        params: {
          kee: null
        },
        controller: 'AuthController as auth',
        templateUrl: 'app/auth/auth.html',
        resolve: {
          hasSession: function (hash, $q, $timeout, $state, $stateParams, UserService) {
            // Si on possède déjà une session et qu'on authentifie pas une kee.
            // on redirige vers l'accueil.
            if (UserService.hasSession() && !$stateParams.kee) {
              $timeout(function () {
                $state.go('app.home', {
                  hash: $stateParams.hash
                });
              });
              return $q.reject();
            }
            return $q.resolve();
          }
        }
      });


    /**
     * Page d'accueuil de WINK.
     * Cette page liste toutes les kees disponibles.
     */

    $stateProvider
      .state('app.home', {
        url: '/home',
        controller: 'HomeController as home',
        templateUrl: 'app/home/home.html',
        resolve: {
          // avant de récupérer les kees.
          kees: function (hash, $q, WinkService) {
            return WinkService.getKees();
          },
          hasOneKee: function (hash, kees, $q, $timeout, $state, $stateParams) {
            // S'il y a une seule kee
            // on redirige directement
            if (kees.length === 1) {
              // get kee
              var kee = kees[0];
              // redirection
              $timeout(function () {
                $state.go('app.kee.' + kee.catalogue.name, {
                  keeId: kee.id,
                  hash: $stateParams.hash
                });
              });
              // reject
              return $q.reject();
            }

            return $q.resolve();
          }
        }
      });



    /**
     * Kees
     */

    $stateProvider
      .state('app.kee', {
        url: '/kee/{keeId}',
        params: {
          hasAuthKee: false
        },
        template: '<div ui-view></div>',
        resolve: {
          // avant de récupérer les kees.
          kees: function (hash, $q, WinkService) {
            return WinkService.getKees();
          },
          // NB : On enregistre la kee qu'on souhaite consulter avant d'entrer sur la kee.
          registerKee: function (hash, kees, $timeout, $state, $q, $stateParams, WinkService) {
            var currentKee = WinkService.registerKee($stateParams.keeId);
            // Si la kee possède un Pin.
            // On réclame une authentification
            if (currentKee.hasPin === true && $stateParams.hasAuthKee !== true) {

              $timeout(function () {
                $state.go('app.auth', {
                  hash: $stateParams.hash,
                  kee: currentKee
                });
              });

              return $q.reject();
            }

            return $q.resolve();
          }
        }
      });

    /**
     * Calendriers des actions
     */


    $stateProvider
      .state('app.kee.action-calendar', {
        url: '/calendrier-des-actions',
        templateUrl: 'app/action-calendar/action-calendar.html',
        controller: 'ActionCalendarController as actionCalendar',
        resolve: {
          // preload des events.
          data: function (hash, kees, ActionCalendarService) {
            return ActionCalendarService.get();
          }
        }
      });

    /**
     * Scrum
     */

    $stateProvider
      .state('app.kee.scrum', {
        url: '/scrum',
        templateUrl: 'app/scrum/scrum.html',
        controller: 'ScrumController as scrum',
        resolve: {
          sprint: function (hash, kees, ScrumService) {
            return ScrumService.get();
          }
        }
      });


    /**
     * Fastrans
     */

    $stateProvider
      .state('app.kee.fastrans', {
        url: '/transmissions',
        templateUrl: 'app/fastrans/fastrans.html',
        controller: 'FastransController as fastrans',
        resolve: {
          transmissions: function (hash, kees, FastransService) {
            return FastransService.get();
          }
        }
      });

    /**
     * Support
     */

    $stateProvider
      .state('app.kee.support', {
        url: '/support',
        templateUrl: 'app/support/support.html',
        controller: 'SupportController as support',
        resolve: {
          support: function (SupportService) {
            return SupportService.get();
          }
        }
      });

    $urlRouterProvider.otherwise('/');
  }

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .constant("API", "http://apps.preprod.socianova.net/wink2/api/public")
.constant("BASE_HREF", "/wink2/");

})();

(function () {
  'use strict';

  angular
    .module('wink')

  /**
   * wink
   */
  .constant('APP_STORAGE_PREFIX', 'snv_wink')
    .constant('WINK', {
      "config": {
        // Calendriers des actions de groupes / usagers.
        "actionCalendar": {
          // 10 minutes, synchronisation des évènements
          "syncInterval": 600,
          // Jours ajoutés depuis aujourd'hui pour l'affichage du calendrier.
          "dayAddedFromToday": 2,
          // heures a retirer à partir l'heure actuelle
          "minTimeFromNow": 3,
          // heures a ajouter à partir de l'heure actuelle
          "maxTimeFromNow": 5
        },
        "fastrans": {
          // 10 minutes
          "syncInterval": 600
        },
        "scrum": {
          // 10 minutes
          "syncInterval": 600
        }
      }
    });

})();

(function () {
  'use strict';

  angular
    .module('wink')
    .config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider, $locationProvider, cfpLoadingBarProvider, toastrConfig) {

    // Enable log
    $logProvider.debugEnabled(false);

    //html5mode
    $locationProvider.html5Mode(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.closeButton = true;
    toastrConfig.progressBar = true;
    toastrConfig.preventDuplicates = false;
    toastrConfig.preventOpenDuplicates = false;

    // angular loading bar
    cfpLoadingBarProvider.includeSpinner = false;

    // $http object
    $httpProvider.defaults.headers.common = {
      'Content-Type': 'application/json;charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest'
    };


    // Intercepteur
    $httpProvider.interceptors.push(function ($injector) {
      return {
        request: function (req) {
          var UserService = $injector.get('UserService');
          // On place le token d'identification dans chaque requête, pour autant qu'il y en ait un.
          if (UserService.getToken()) {
            req.headers.Authorization = UserService.getToken();
          }
          return req;
        }
      };
    });

  }

})();

angular.module("wink").run(["$templateCache", function($templateCache) {$templateCache.put("app/action-calendar/action-calendar.html","<navbar title=\"Calendrier des actions\" reload=actionCalendar.autoreload() menu=true timer=true></navbar><!-- FILTER --><div class=container><div class=row><div class=col-xs-12><!-- Filter container --><div class=filter-container><div class=form-inline><div class=form-group><div class=checkbox><label><input type=checkbox ng-model=actionCalendar.toggle.showCompleteCalendar ng-checked=actionCalendar.toggle.showCompleteCalendar> <i class=\"fa fa-calendar\"></i> Afficher le calendrier complet</label></div></div></div></div></div></div></div><div class=calendar-ctrl><div class=container-fluid><div class=row><div class=\"col-xs-12 col-md-2\"><ul class=member-groups><li ng-style=\"{\'background\' : group.color}\" ng-repeat=\"group in actionCalendar.groups track by $index\">{{group.name}}</li></ul></div><div class=\"col-xs-12 col-md-10\"><!-- Fullcalendar directive --><div ui-calendar=actionCalendar.fullCalendarConfiguration class=\"span8 calendar\" calendar=winkCalendar></div></div></div></div></div>");
$templateCache.put("app/auth/auth.html","<div class=auth-background><div class=container-fluid><div class=row><div class=\"col-xs-12 col-md-4 col-md-offset-4\"><form class=login-form name=pinForm ng-submit=auth.accessByPin()><!-- Form group --><div class=form-group><label for=pin>Entrez votre code PIN</label><input type=password id=pin name=pin ng-model=auth.form.pin placeholder=\"Code PIN\" required maxlength=4 autofocus></div><div class=alert-form ng-if=auth.form.error><i class=\"fa fa-warning\"></i> <b>Code PIN invalide</b></div><button type=submit class=\"btn btn-primary btn-lg btn-block\" ng-disabled=pinForm.$invalid>Connexion</button></form></div></div></div></div>");
$templateCache.put("app/error-pages/401.html","<div class=\"container container-error-pages\"><div class=row><div class=\"col-xs-12 text-center\"><img src=assets/images/401.png alt=\"Error 404\"><h1>Halte, 401 !</h1><p><b>Désolé</b>, vous ne pouvez pas accéder à cette page car <a href=http://www.mon-ip.com/ title=\"Cliquez ici pour connaître votre adresse ip\">votre adresse IP</a> n\'est pas authentifiée.</p></div></div></div>");
$templateCache.put("app/error-pages/404.html","<div class=\"container container-error-pages\"><div class=row><div class=\"col-xs-12 text-center\"><img src=assets/images/404.png alt=\"Error 404\"><h1>Oups, 404 !</h1><p>La page que vous recherchez n\'existe pas.</p></div></div></div>");
$templateCache.put("app/fastrans/fastrans.html","<navbar title=Transmissions reload=fastrans.autoreload() menu=true></navbar><!-- FILTER --><div class=container><div class=row><div class=col-xs-12><!-- Filter container --><div class=filter-container><div class=form-inline><div class=form-group><div class=checkbox><label><input type=checkbox ng-model=fastrans.toggle.important ng-checked=fastrans.toggle.important> <i class=\"fa fa-exclamation-triangle\"></i> Transmissions importantes</label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox ng-model=fastrans.toggle.medical ng-checked=fastrans.toggle.medical> <i class=\"fa fa-bullseye\"></i> Transmissions médicales</label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox ng-model=fastrans.toggle.nocturne ng-checked=fastrans.toggle.nocturne> <i class=\"fa fa-moon-o\"></i> Transmissions de nuit</label></div></div></div></div></div></div></div><div class=container-fluid><!-- TIMELINE --><div class=row><div class=col-xs-12><timeline><!-- Scroll infini. --><div infinite-scroll=fastrans.nextPage() infinite-scroll-disabled=fastrans.infiniteScroll.busy infinite-scroll-distance=1 infinite-scroll-immediate-check=false><timeline-event ng-repeat=\"transmission in fastrans.data track by $index\" side=left><!-- Timeline Badge --><timeline-badge ng-class=\"{\'badge-important\' : transmission.important}\"><i class=\"fa {{transmission.badge}}\"></i></timeline-badge><!-- Timeline Panel --><timeline-panel ng-class=\"{\'lisere-medical\' : transmission.medical, \'lisere-nocturne\' : transmission.nocturne}\"><!-- Timeline heading --><timeline-heading><!-- Date --><p class=pull-right><b>{{transmission.date_fait | amDateFormat : \'DD/MM/YYYY HH:mm\'}} ({{transmission.timeAgo}})</b></p><!-- Titre --><h1 class=title>{{transmission.name}}</h1><!-- Usagers --><h2 class=usg ng-if=\"transmission.beneficiaires && transmission.beneficiaires.length > 0\"><i class=\"fa fa-users\"></i> <span ng-repeat=\"usager in transmission.beneficiaires\">{{usager.name}} <span ng-if=!$last>,</span></span></h2><!-- Catégorie --><h2 class=categorie><i class=\"fa fa-folder\"></i> {{transmission.categorie}}</h2><!-- Catégorie --><h2><i class=\"fa fa-pencil\"></i> {{transmission.create_user}}</h2></timeline-heading><!-- Description --><div class=description ng-if=transmission.description><b>Description :</b><br><p ng-bind-html=transmission.description></p></div><!-- Commentaires. --><div class=comments ng-if=transmission.print_comments><b>Commentaires :</b><br><p ng-bind-html=transmission.print_comments></p></div></timeline-panel></timeline-event></div></timeline><div class=\"text-center infinite-scroll-loader\" ng-if=fastrans.infiniteScroll.busy><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div></div></div></div><!-- Back to top --><back-top button-theme=light><i class=\"fa fa-arrow-up\" style=font-size:1.5em></i></back-top>");
$templateCache.put("app/home/home.html","<navbar navigate=false title=\"Bienvenue sur Wink\"></navbar><div class=\"container home\"><div class=row><div class=col-xs-12><h3 class=\"text-center title\">Bonjour {{home.user}}</h3></div></div><section class=kee><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-repeat=\"kee in home.kees\"><div class=card ng-click=home.navigate(kee)><i class=\"fa help fa-question-circle\" aria-hidden=true></i><div class=text-center><i class=\"fa fa-{{kee.catalogue.icon}} fa-4x\"></i></div><div class=card-container><h4><b>{{kee.catalogue.display_name}}</b></h4><p>{{kee.catalogue.description}}</p></div></div></div></section></div>");
$templateCache.put("app/logout/logout.html","<div class=\"container container-error-pages\"><div class=row><div class=\"col-xs-12 text-center\"><i class=\"fa fa-sign-out fa-5x\"></i><p>Vous avez été deconnecté avec succès. À bientôt!</p></div></div></div>");
$templateCache.put("app/scrum/scrum.card.template.html","<div class=\"panel panel-default\" ng-class=\"{\'lisere\' : scrumCard.showLisere}\" ng-style=\"scrumCard.showLisere && {\'border-left-color\':task.responsable_support.color}\" ng-click=\"scrumCard.hideContent = !scrumCard.hideContent\" uib-popover-html=scrumCard.popover.content popover-title={{scrumCard.popover.title}} popover-placement=\"\'auto\'\" popover-trigger=\"\'mouseenter\'\"><!-- Panel heading --><div class=panel-heading ng-class=\"{\'md10\' : task.md10 && scrumCard.column === \'pending\'}\"><!-- COmpelxité --><div class=complexity ng-if=\"scrumCard.column !== \'finished\'\">{{task.complexity ? task.complexity : \'?\' }}</div><!-- Icone indiquant merge request ou valide --><div class=icon-finished ng-if=\"scrumCard.column === \'finished\'\"><i class=\"fa fa-compress text-warning\" ng-if=task.mr></i> <i class=\"fa fa-check text-success\" ng-if=!task.mr></i></div><!-- Titre. --><div class=title><img ng-if=scrumCard.showResponsable ng-src={{task.responsable_support.gravatar}} class=gravatar alt=\"\"> <span class=id>{{task.model == \'SupportIssue\' ? \'#\' : \'$\'}}{{task.id}} </span>{{task.name}}</div></div></div>");
$templateCache.put("app/scrum/scrum.html","<navbar title=\"{{scrum.sprint.name}} | {{scrum.sprint.start | amDateFormat : \'DD MMMM\'}} au {{scrum.sprint.end | amDateFormat : \'DD MMMM\'}}\" reload=scrum.autoreload() menu=true></navbar><div class=\"text-center no-sprint\" ng-if=!scrum.sprint><h3>Aucun sprint pour le moment =(</h3></div><div class=\"container-fluid container-scrum\" ng-if=scrum.sprint><!-- Contenu d\'intro --><div class=intro><!-- Progressions --><div><b>Réalisation :</b> {{scrum.statistics.numberOfTasksDone + \'/\' + scrum.statistics.numberOfTasks }} ({{scrum.statistics.delivery + \'%\'}})</div><div class=\"progress progress-delivery progress-striped\"><div class=\"progress-bar progress-bar-success\" ng-style=\"{\'width\' : scrum.statistics.delivery + \'%\'}\"></div></div><div><i class=\"fa fa-circle text-danger timer-indicator\" ng-style=\"{\'left\': (scrum.statistics.timer) + \'%\'}\"></i></div><div class=\"progress progress-time\"><div class=\"progress-bar progress-bar-danger\" ng-style=\"{\'width\' : scrum.statistics.timer + \'%\'}\"></div></div><div class=\"progress progress-complexity progress-striped\"><div class=\"progress-bar progress-bar-warning\" ng-style=\"{\'width\' : scrum.statistics.complexity.total + \'%\'}\"></div></div><div><b>Complexité :</b> {{scrum.statistics.numberOfComplexityDone + \'/\' + scrum.statistics.numberOfComplexity}} ({{scrum.statistics.complexity.total + \'%\'}})</div></div><!-- Tâches divisées par statut --><div class=\"row content\"><!-- Colonnes --><!-- Pending request --><div class=\"col-xs-12 col-sm-12 col-md-{{scrum.columns.pending}} master-column right-border\"><h2>En attente ({{scrum.sprint.pending.length}} - <span class=complexity>{{scrum.statistics.complexity.pending}}</span>)</h2><!-- No tasks. --><div class=text-center ng-if=\"scrum.sprint.pending.length === 0\"><i class=\"fa fa-check fa-3x\"></i><p>Aucune tâche. <b>Bravo les gars!</b></p></div><!-- Pending cards --><div class=\"child-column col-xs-12\" ng-class=\"{\'col-sm-12\' : scrum.columns.pending <= 6, \'col-sm-4\' : scrum.columns.pending >= 6}\" ng-repeat=\"task in scrum.sprint.pending\"><scrum-card column=pending task=task></scrum-card></div></div><!--  --><!-- Progress request --><!--  --><div class=\"col-xs-12 col-sm-12 col-md-{{scrum.columns.progress}} master-column right-border\"><h2>En cours ({{scrum.sprint.progress.length}} - <span class=complexity>{{scrum.statistics.complexity.progress}}</span>)</h2><!-- No tasks. --><div class=text-center ng-if=\"scrum.sprint.progress.length === 0 && scrum.sprint.pending.length === 0\"><i class=\"fa fa-check fa-3x\"></i><p>Aucune tâche. <b>La grande CLASSE!</b></p></div><!-- Progress cards --><div class=\"child-column col-xs-12\" ng-class=\"{\'col-sm-12\' : scrum.columns.progress <= 6, \'col-sm-4\' : scrum.columns.progress >= 6}\" ng-repeat=\"task in scrum.sprint.progress\"><scrum-card column=progress task=task lisere=true></scrum-card></div></div><!--  --><!-- Finished request --><!--  --><div class=\"col-xs-12 col-sm-12 col-md-{{scrum.columns.finished}} master-column\"><h2>Terminées ({{scrum.sprint.finished.length}})</h2><!-- No tasks. --><div class=text-center ng-if=\"scrum.sprint.finished.length === 0\"><i class=\"fa fa-check fa-3x\"></i><p>Aucune tâche.</p></div><!-- finished cards --><div class=\"child-column col-xs-12\" ng-class=\"{\'col-sm-12\' : scrum.columns.finished <= 6, \'col-sm-4\' : scrum.columns.finished >= 6}\" ng-repeat=\"task in scrum.sprint.finished\"><scrum-card column=finished task=task lisere=true></scrum-card></div></div></div></div>");
$templateCache.put("app/support/support.html","<navbar title=\"Demandes de support\" reload=support.autoreload() menu=true></navbar><!-- Statistiques --><div class=\"container-fluid container-stats\"><div class=\"row text-center\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><span class=number>{{support.statistics.new}} / <span class=block>{{support.statistics.newblock}}</span></span><br><span class=title>Nouvelles demandes</span></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><span class=number>{{support.statistics.open}} / <span class=block>{{support.statistics.openblock}}</span></span><br><span class=title>Demandes ouvertes</span></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><span class=number>{{support.statistics.age}}</span><br><span class=title>Âge moyen</span></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><slick settings=support.slickResponsibleConfig ng-if=support.dataLoaded><div ng-repeat=\"responsible in support.responsibles\" class=responsable><span class=pull-left>{{responsible.name}}</span> <span class=pull-right>{{responsible.issues}}</span><b></b></div></slick><span class=title>Responsables</span></div></div></div><!-- Issues. --><section class=container-support><!-- Display image --><!-- On affichage cette image lorsqu\'une il n\'y aucune demande en attente. --><div class=\"text-center great-work\" ng-if=\"support.issues.length == 0\"><img src=assets/images/great-work.png alt=\"Great work!!\"></div><!-- Containrr --><!-- S\'affiche si  --><div class=container-without-slick ng-if=\"support.issues.length <= 3\"><div class=col-xs-12 ng-class=\"{\'col-md-4\' : support.issues.length == 3 , \'col-md-6\' : support.issues.length <= 2, \'col-md-offset-3\' : support.issues.length == 1}\" ng-repeat=\"issue in support.issues\"><!-- Panel issue  --><support-issue issue=issue></support-issue></div></div><!-- Slick container --><!-- Actif si plus de 3 demandes dans le stack --><div class=container-slick><slick settings=support.slickIssuesConfig ng-if=support.dataLoaded><!-- Slick repeat --><div ng-repeat=\"issue in support.issues\"><!-- Panel issue  --><support-issue issue=issue></support-issue></div></slick></div></section>");
$templateCache.put("app/support/supportIssue.template.html","<div class=\"panel panel-default issue\" ng-class=\"{\'important\' : supportIssue.issue.is_high, \'normal\' : !supportIssue.issue.is_high}\"><div class=panel-heading><i class=\"fa fa-clipboard fa-cursor\" ng-click=copyClipboard() ngclipboard data-clipboard-text={{supportIssue.issue.id}}></i> #{{supportIssue.issue.id}} - {{supportIssue.issue.instance.user}} @ {{supportIssue.issue.instance.name}}<br>{{supportIssue.issue.name}}</div><div class=panel-body><div class=text-right><span class=\"timeAgo small\">{{supportIssue.issue.create_date | timeAgo}} </span><span class=\"label label-success\" ng-if=supportIssue.issue.medical>Médical</span> <span class=\"label label-warning\" ng-if=supportIssue.issue.security>Securité</span></div><div ng-bind-html=\"supportIssue.issue.description | words:200\"></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-default\"><div class=container-fluid><div class=navbar-header><button ng-if=navbar.menu type=button class=\"btn btn-primary navbar-btn pull-left\" ui-sref=app.home><i class=\"fa fa-bars fa-2x\"></i></button> <a class=navbar-brand>{{navbar.title}}</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"></ul><ul class=\"nav navbar-nav navbar-right\"><li ng-if=navbar.timer class=timer><a>{{navbar.timer}}</a></li><li ng-if=navbar.navigate><button type=button class=\"btn btn-primary navbar-btn\" ng-click=navbar.prev()><i class=\"fa fa-arrow-left fa-2x\"></i></button></li><li ng-if=navbar.navigate><button type=button class=\"btn btn-primary navbar-btn\" ng-click=navbar.next()><i class=\"fa fa-arrow-right fa-2x\"></i></button></li><li ng-if=navbar.reload><button type=button class=\"btn btn-primary navbar-btn\" ng-click=navbar.doReload()><i class=\"fa fa-repeat fa-2x\"></i></button></li><li><button type=button class=\"btn btn-primary navbar-btn\" ng-click=navbar.logout()><i class=\"fa fa-power-off fa-2x\"></i></button></li></ul></div></div></nav>");}]);